export default __webpack_public_path__ + "static/media/face_confused_yellow.e3fdf783.svg";